import * as THREE from 'three';


import Store from '../Store';



export default class Cursor {
  constructor() {
    const { scene, cursorOpacity, } = Store.getState();

    this.innerRadius = 0.2;
    this.outerRadius = 0.25;
    this.thetaSegments = 64;

    // Create mesh with initial geometry and material
    const geometry = new THREE.RingGeometry(this.innerRadius, this.outerRadius, this.thetaSegments);
    const material = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      side: THREE.DoubleSide,
      transparent: true,
      depthTest: true,
      depthWrite: true,
      opacity: cursorOpacity
    });
    
    this.mesh = new THREE.Mesh(geometry, material);
    this.mesh.renderOrder = 11;
    
    // Add mesh to scene
    scene.add(this.mesh);

    // initial update
    this.updateParameters();
    this.raycaster = new THREE.Raycaster();
  } 


  handleIntersection(point) {
    const { app, } = Store.getState();

    if (app.flowers) {
      app.flowers.makeFlower(point);
    }
  }

  // This method will be called in the animation loop to position the cursor
  update() {
    const { app, cursor } = Store.getState();
    this.mesh.position.copy(cursor.position);
    this.mesh.rotation.setFromQuaternion(cursor.rotation);
    // this.mesh.lookAt(this.mesh.position.clone().add(cursor.rotation)); // This aligns the mesh with the normal

    this.updateParameters();


    // if you need to raycast to log something in the world that the cursor is intersecting with
    // Update raycaster
    this.raycaster.set(cursor.position, new THREE.Vector3(0, 0, -1).applyQuaternion(cursor.rotation));

    // Check for intersections with dollhouse
    let intersects = [];

    if (app.dollhouse && app.dollhouse.gltf && app.dollhouse.gltf.scene) {
      app.dollhouse.gltf.scene.children.forEach((child, i) => {
        const childIntersects = this.raycaster.intersectObject(child);
        Array.prototype.push.apply(intersects, childIntersects);
      });
    }

    if (intersects.length > 0) {
      const worldIntersectionPoint = intersects[0].object.localToWorld(intersects[0].point.clone());
      this.handleIntersection(intersects[0].point.clone());
      // console.log("intersectionpoint", intersects[0].point.clone());
    }
  }

  updateParameters() {
    const { cursor, cursorOpacity } = Store.getState();

    if (
        cursor.position.x === 0 &&
        cursor.position.y === 0 &&
        cursor.position.z === 0
    ) {
      this.mesh.visible = false;
    } else {
      this.mesh.visible = true;
    }

    this.mesh.material.opacity = cursorOpacity;
  }
}
